import React, {Component} from 'react';

//scss
import memberInfostyles from '../../static/css/componentStyleModules/memberInfoSheet.module.scss';

//API
import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI.js';

import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent';
import PieChartComponent from './PieChartComponent';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';


export default class MemberInfoSheetComponent extends Component {

    constructor(props){
        super(props);
        this.state = {

            thanksData:{allThanksNumber:0,checkedThanksNumber:0,thanksPercent:0},
            dataListForPieChart:[{rate:0,color:'#666666'},{rate:100,color:'#666666'}],
            isThanksLoaded:false,

        }
    }

    componentWillMount = () => {
        //ありがとデータ取得
        //メンバーのありがとを取得してきて、数をしらべる
        ThanksControllerAPI.index( {member_id:this.props.memberData.id} )
        .then((result) => {
            
            if(result.data.allThanksNumber > 0){
                const thanksPersent = result.data.thanksPercent;            

                const dataListForPieChart = [
                    {rate:thanksPersent,color:'hsl(6,77%,62%)'},
                    {rate:(100 - thanksPersent),color:'#666666'}
                ] 

                this.setState({
                    thanksData:result.data,
                    dataListForPieChart:dataListForPieChart,
                });
            }else{
                
                this.setState({
                    thankData:{allThanksNumber:0,checkedThanksNumber:0,thanksPercent:0},
                    dataListForPieChart:[{rate:0,color:'#666666'},{rate:100,color:'#666666'}],
                })
            }

            process.nextTick(() => {
                setTimeout(() => {
                    this.setState({isThanksLoaded:true});
                },100)
            })
                                  
        })
        .catch((error) => {
            console.log(error);     
        })
    }

    render() {

        const sheetFunctionButton = (buttonAction,icon,buttonStr,deleteButton) => {
            const memberColor = this.props.memberData.color !== null ? this.props.memberData.color : '#888888';

            return (
                <div className={memberInfostyles['functionButton'] + ' touchActiveDark'}
                onClick={buttonAction}
                >
                  <div className={memberInfostyles['iconArea']}
                  style={ deleteButton ? null : {backgroundColor:memberColor}}
                  >
                    <div className={memberInfostyles['icon']}>
                      <SvgIconBaseComponent 
                      image={icon} 
                      fillColor={deleteButton ? '#c7243a' : '#ffffff'} 
                      />
                    </div>
                  </div>
                  <span>{buttonStr}</span>
                </div>
            )
        }

        return (
            <div className={memberInfostyles['memberSheet']}>
              <div className={memberInfostyles['mainInfo']}>
                <h2>{this.props.memberData.name}</h2>
                <div className={memberInfostyles['faceIconRack']}>
                  <div className={memberInfostyles['faceIcon']}
                  style={{borderColor:this.props.memberData.color}}
                  >
                    <FaceIconBaseComponent 
                    head={this.props.memberData.head}
                    eyes={this.props.memberData.eyes}
                    eyeblows={this.props.memberData.eyeblows}
                    mouth={this.props.memberData.mouth}
                    fillColor={this.props.memberData.color} />
                  </div>
                </div>

                <div className={
                  this.state.isThanksLoaded 
                  ? memberInfostyles['graphRack'] 
                  : memberInfostyles['graphRack'] + ' ' + memberInfostyles['hidden']
                }>
                  <div className={memberInfostyles['pieChartArea']}>
                    <PieChartComponent 
                    dataList={this.state.dataListForPieChart}
                    holeSizePercent={80}
                    />
                    <div className={memberInfostyles['percentDisplay']}>
                      <strong>{this.state.thanksData.thanksPercent}</strong>
                      <span>%</span>
                    </div>
                  </div>
                  <div className={memberInfostyles['dataDisplayArea']}>
                    <div className={memberInfostyles['dataRack']}>
                      <div className={memberInfostyles['dataRackLeft']}>
                        <SvgIconBaseComponent image={'facedHeart'} fillColor={'hsl(6,77%,62%)'} />
                      </div>
                      <div className={memberInfostyles['dataBorder']} />
                      <div className={memberInfostyles['dataRackRight']}>
                        {this.state.thanksData.checkedThanksNumber}
                      </div>
                    </div>
                    <div className={memberInfostyles['dataRack']}>
                      <div className={memberInfostyles['dataRackLeft']}>
                        <SvgIconBaseComponent image={'facedHeart'} fillColor={'#888888'} />
                      </div>
                      <div className={memberInfostyles['dataBorder']} />
                      <div className={memberInfostyles['dataRackRight']}>
                        {this.state.thanksData.allThanksNumber - this.state.thanksData.checkedThanksNumber}
                      </div>
                    </div>
                  </div>
                </div>

                {this.props.memberData.memo !== '' && 
                  <div className={memberInfostyles['memoRack']}>
                    <p>{this.props.memberData.memo}</p>
                  </div>
                }

                <div className={memberInfostyles['functionButtonRack']}>
                  <div className={memberInfostyles['leftArea']}>
                    {sheetFunctionButton(this.props.onDelButtonClick,'heartBreak','忘れる',true)}
                  </div>
                  <div className={memberInfostyles['rightArea']}>
                    {sheetFunctionButton(this.props.onEditButtonClick,'pencil','編集')}
                  </div>
                </div>

              </div>
            </div>
        )
    }

};